import { h, Fragment } from "preact";
import { useState, useMemo, useEffect } from "preact/hooks";
import ShippingMethods from "./shipping-methods";
import SelectAddress from "./select-address";

const addressKeysAllowlist = [
  "firstName",
  "lastName",
  "company",
  "address1",
  "address2",
  "city",
  "provinceCode",
  "zip",
  "countryCode",
];

const sanitizeAddress = (address) => {
  const sanitizedAddress = {};

  Object.entries(address).forEach(([key, value]) => {
    if (value && addressKeysAllowlist.includes(key)) {
      sanitizedAddress[key] = value;
    }
  });

  return sanitizedAddress;
};

export default function QuoteModal({ data }) {
  const { addresses, countries, quotesUrl } = data;
  const [note, setNote] = useState(window.cartData.note || "");
  const [billingAddress, setBillingAddress] = useState(null);
  const [shippingAddress, setShippingAddress] = useState(null);
  const [deliveryOptionHandle, setDeliveryOptionHandle] = useState(null);
  const [loading, setLoading] = useState(false);
  const [saved, setSaved] = useState(false);
  const [error, setError] = useState(null);
  const storefrontCartId = window.cartData.id;

  const saveQuote = () => {
    setError(null);
    setLoading(true);
    const body = {};

    if (note.length) {
      body.note = note;
    }

    if (billingAddress) {
      body.billingAddress = sanitizeAddress(billingAddress);
    }

    if (shippingAddress) {
      body.shippingAddress = sanitizeAddress(shippingAddress);
    }

    if (deliveryOptionHandle) {
      body.shippingLine = {
        shippingRateHandle: deliveryOptionHandle,
      };
    }

    window.saveQuote(body, {
      onAfterSave: () => {
        setSaved(true);
        setLoading(false);
        window.reloadCart();
      },
      onError: () => {
        setError(window.localeStrings.save_quote.quote_error);
        setLoading(false);
      },
    });
  };

  if (!storefrontCartId) return <div>Error: missing storefront cart ID</div>;

  if (saved) {
    return (
      <div className="save-quote__content">
        <div className="save-quote__saved">
          {window.localeStrings.save_quote.quote_saved}
        </div>
        <a href={quotesUrl} className="link link--black">
          {window.localeStrings.cart.view_quotes}
        </a>
      </div>
    );
  }

  return (
    <div className="save-quote__content">
      <label className="input-label">
        <span className="save-quote__field-label-text">
          {window.localeStrings.save_quote.add_comment}
        </span>
        <textarea
          className="save-quote__comment"
          value={note}
          onChange={(e) => setNote(e.target.value)}
        ></textarea>
      </label>
      <SelectAddress
        label={window.localeStrings.save_quote.billing_address}
        addresses={addresses}
        selectedAddress={billingAddress}
        setSelectedAddress={setBillingAddress}
      />
      <div>
        <SelectAddress
          label={window.localeStrings.save_quote.shipping_address}
          addresses={addresses}
          selectedAddress={shippingAddress}
          setSelectedAddress={setShippingAddress}
          allowCustom={true}
          countries={countries}
        />
      </div>
      <ShippingMethods
        deliveryOptionHandle={deliveryOptionHandle}
        setDeliveryOptionHandle={setDeliveryOptionHandle}
        shippingAddress={shippingAddress}
        storefrontCartId={storefrontCartId}
      />
      <div className="save-quote__footer">
        <button
          className="button button--black save-quote__save"
          onClick={saveQuote}
          disabled={loading}
        >
          {loading
            ? window.localeStrings.save_quote.saving
            : window.localeStrings.save_quote.save_quote}
        </button>
        <button
          className="button button--black-outline save-quote__cancel"
          data-close
        >
          {window.localeStrings.save_quote.cancel}
        </button>
        {error && <div className="save-quote__error">{error}</div>}
      </div>
    </div>
  );
}
